module.exports = __webpack_public_path__ + "static/media/ribbon-specialoffer-it@3x.3c580a2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ribbon-specialoffer-it@3x.png
// module id = 312
// module chunks = 0